import { render, staticRenderFns } from "./LabelGenForm.vue?vue&type=template&id=b9c45610"
import script from "./LabelGenForm.vue?vue&type=script&lang=js"
export * from "./LabelGenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports